import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index'

const basePath = '/v-admin/job-application-invitation'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    permission: 'PREMIUM_APPLICATION_FORM',
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: 'admin.company.jobApplication.title.invitation',
    menu: {
      get label () {
        return i18n.t('admin.company.jobApplication.menu.invitation')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.jobApplication.title.invitation'
      }
    }
  ]
}
